import React from 'react';
import '../styles/MapPerformanceTable.css';

const LastHPMatchesTable = ({ data, limit, onLimitChange }) => {
  if (!data || data.length === 0) {
    return <p className="last-games-empty">No HP matches in the selected range.</p>;
  }

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  return (
    
        <div className="table-wrapper">
        <table className="performance-table performance-table--last">
          <thead>
            <tr>
              <th>Date</th>
              <th>Opponent</th>
              <th>Match Type</th>
              <th>Map</th>
              <th>Result</th>
              <th>PF</th>
              <th>PA</th>
              <th>[+/-]</th>
            </tr>
          </thead>
          <tbody>

{data.map((match, idx) => {
  const pf = Number(match.PF) || 0;
  const pa = Number(match.PA) || 0;
  const diff = pf - pa;
  return (
    <tr
      key={idx}
      className={
        match.WinLose === 'WIN'
          ? 'win-row'
          : match.WinLose === 'LOSE'
          ? 'loss-row'
          : ''
      }
    >
      <td>{formatDate(match.Date)}</td>
      <td>{match.EnemyTeam}</td>
      <td>{match.MatchType}</td>
      <td>{match.Map}</td>
      <td style={{ fontWeight: 'bold' }}>{match.WinLose}</td>
      <td>{pf}</td>
      <td>{pa}</td>
      <td>{diff > 0 ? `+${diff}` : diff}</td>
    </tr>
  );
})}



          </tbody>
        </table>
      </div>
 
  
  );
};

export default LastHPMatchesTable;
